import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { resolve } from 'dns';
import { Observable } from 'rxjs';
import { AuthService } from './shared/services/auth_service';


@Injectable()
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        public authenticationService: AuthService
    ) {}

    canActivate(): boolean | Observable<boolean> | Promise<boolean> {
        return new Promise((resolve, reject) => {
            this.authenticationService.isLoggedIn().then((val) => {
                if (val) {
                    resolve(true);
                }
                else{
                    console.log('User is not logged in');
                    this.router.navigate(['/signup', { replaceUrl: true }]);
                    resolve(false);
                }
            }).catch((error) => {
                console.log('User is not logged in');
                this.router.navigate(['/signup', { replaceUrl: true }]);
                resolve(false);
            });
        })
    }

}